import {
    Actions,
    AugmentedActionContext,
    CategorySeenDates, Getters,
    Mutations,
    MutationTypes,
    State
} from './EventCategorySeenState.types';
import Api from '../../../scripts/api';

const state: State = {
    categorySeenState: null,
};

const mutations: Mutations = {
    async SET_CATEGORY_SEEN (state: State, payload: { category: string }) {
        await Api.version(1).put(`events/categories/${payload.category}/seen`);
    },

    LOAD_STATE (state: State, payload: { categorySeenState: CategorySeenDates }): void {
        state.categorySeenState = payload.categorySeenState;
    },
};

const actions: Actions = {
    async loadState ({ commit, state }: AugmentedActionContext) {
        if (state.categorySeenState !== null) {
            return;
        }
        // commiting a temporary empty object to prevent further calls to loadState() from loading again
        commit(MutationTypes.LOAD_STATE, { categorySeenState: {} });

        const categoriesLastSeen: CategorySeenDates = await Api.version(1).get('events/categories/seen');

        commit(MutationTypes.LOAD_STATE, { categorySeenState: categoriesLastSeen });
    },
    setCategorySeenDate ({ commit }: AugmentedActionContext, payload: { category: string }) {
        commit(MutationTypes.SET_CATEGORY_SEEN, payload);
    },
};

const getters: Getters = {
    categoryLastSeenDates (state: State): CategorySeenDates {
        return state.categorySeenState;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
